<template>
  <tr>
    <td
      class="cell"
      :style="cellStyle"
    >
      {{ summaryName }}
    </td>
    <td
      class="cell text-center"
      :style="cellStyle"
    >
      {{ formatAsCurrency(summaryInfo.BudgetAmount) }}
    </td>
    <td
      class="cell text-center"
      :style="cellStyle"
    >
      {{ formatAsCurrency(summaryInfo.ActualAmount) }}
    </td>
    <td
      class="cell text-center"
      :class="{ 'text-red': summaryInfo.RemainingBudget < 0, 'text-green': summaryInfo.RemainingBudget > 0 }"
      :style="cellStyle"
    >
      {{ formatAsCurrency(summaryInfo.RemainingBudget) }}
    </td>
  </tr>
</template>

<script>
import formatter from '@/services/formatter.js'

export default {
  name: 'BudgetSummaryLine',
  props: {
    summaryName: {
      type: String,
      default: ''
    },
    summaryInfo: {
      type: Object,
      default: function () {
        return {}
      }
    },
    cellStyle: {
      type: Object,
      default: function () {
        return {}
      }
    },
    headerCellStyle: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  methods: {
    formatAsCurrency: function (value) {
      return formatter.formatAsCurrency(value)
    },
    formatAsPercent: function (value) {
      return formatter.formatAsPercent(value)
    }
  }
}
</script>
